import { render, staticRenderFns } from "./ProposalTutorialSlider.vue?vue&type=template&id=ff641060&scoped=true"
import script from "./ProposalTutorialSlider.vue?vue&type=script&lang=js"
export * from "./ProposalTutorialSlider.vue?vue&type=script&lang=js"
import style0 from "./ProposalTutorialSlider.vue?vue&type=style&index=0&id=ff641060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff641060",
  null
  
)

export default component.exports